module.exports = __webpack_public_path__ + "static/media/fechar-menu-mobile.cf201a18.svg";